module.exports = __webpack_public_path__ + "media/images/client-28-4772200e3162846cefc65260673d12ba.png";